/** @jsxImportSource @emotion/react */
'use client'

import GroupAddIcon from '@mui/icons-material/GroupAdd'
import Typography from '@mui/material/Typography'
import { FlexCol } from '../layout'
import StatCardShell from './StatCardShell'
import { styles } from './styles'

/**
 * Growth stat — new clients signed across the insurance industry since BIBA.
 * The focal value pairs a featured-card icon chip with the headline.
 */
export default function ClientsStatCard() {
	return (
		<StatCardShell
			kicker="Growth"
			tone="light"
			footer={
				<Typography
					component="p"
					css={[styles.description, styles.descriptionTone.light]}
				>
					Multiple new partners onboarded in the seven weeks since BIBA.
				</Typography>
			}
		>
			<FlexCol gap="md" align="start">
				<span css={styles.iconChip}>
					<GroupAddIcon color="success" fontSize="large" />
				</span>
				<Typography component="p" css={[styles.metricSm, styles.headingFont]}>
					New clients signed across insurance
				</Typography>
			</FlexCol>
		</StatCardShell>
	)
}
